import { createAction, props } from '@ngrx/store';
import {
	NdcDestinationImportFileSearchModel,
	SearchResponse,
	SearchRequest,
	ImportFileRecordsResult,
	NdcDestinationValidationErrorSearchModel,
	NdcDestinationFileDetailsFilterModel,
	NdcDestinationOverlapPairModel,
	AutoResolveExistingNdcDestinationModel,
	DeleteImportedNdcDestinationRecordModel,
	UpdateExistingNdcDestinationTerminationDateModel,
	UpdateImportedNdcDestinationRecordModel,
	FilterSearchRequest
} from '@twrx-api-models';

import { ActionRequestPayload } from '../action-request-payload';
import { NdcDestinationImportFileModel } from '../../models/dto/ndc-destination-import-file-model';
import { UploadFileResponse } from '../../models/dto/upload-file-response';
import { ActionResponsePayload } from '../action-response-payload';

export enum NdcDestinationImportActions {
	LoadImportFiles = '[NdcDestinationImportActions] LoadImportFiles',
	ImportFilesLoaded = '[NdcDestinationImportActions] ImportFilesLoaded',

	UploadImportFile = '[NdcDestinationImportActions] UploadImportFile',
	ImportFileUploaded = '[NdcDestinationImportActions] ImportFileUploaded',

	LoadValidationErrors = '[NdcDestinationImportActions] LoadValidationErrors',
	ValidationErrorsLoaded = '[NdcDestinationImportActions] ValidationErrorsLoaded',

	LoadDateOverlaps = '[NdcDestinationImportActions] LoadDateOverlaps',
	DateOverlapsLoaded = '[NdcDestinationImportActions] DateOverlapsLoaded',
	ClearDateOverlaps = '[NdcDestinationImportActions] ClearDateOverlaps',

	AutoResolveDateOverlap = '[NdcDestinationImportActions] AutoResolveDateOverlap',
	DateOverlapAutoResolved = '[NdcDestinationImportActions] DateOverlapAutoResolved',

	UpdateSystemTerminationDate = '[NdcDestinationImportActions] UpdateSystemTerminationDate',
	SystemTerminationDateUpdated = '[NdcDestinationImportActions] SystemTerminationDateUpdated',

	UpdateImportedOverlapRecord = '[NdcDestinationImportActions] UpdateImportedOverlapRecord',
	ImportedOverlapRecordUpdated = '[NdcDestinationImportActions] ImportedOverlapRecordUpdated',

	DeleteImportedOverlapRecord = '[NdcDestinationImportActions] DeleteImportedOverlapRecord',
	ImportedOverlapRecordDeleted = '[NdcDestinationImportActions] ImportedOverlapRecordDeleted',

	BulkAutoFixDateOverlaps = '[NdcDestinationImportActions] BulkAutoFixDateOverlaps',
	DateOverlapsBulkAutoFixed = '[NdcDestinationImportActions] DateOverlapsBulkAutoFixed',

	RemoveImportFile = '[NdcDestinationImportActions] RemoveImportFile',
	ImportFileRemoved = '[NdcDestinationImportActions] ImportFileRemoved',

	ErrorOccurred = '[NdcDestinationImportActions] ErrorOccurred'
}

export const loadImportFiles = createAction(
	NdcDestinationImportActions.LoadImportFiles,
	props<ActionRequestPayload<SearchRequest>>()
);

export const importFilesLoaded = createAction(
	NdcDestinationImportActions.ImportFilesLoaded,
	props<
		ActionResponsePayload<
			SearchResponse<NdcDestinationImportFileSearchModel>
		>
	>()
);

export const uploadImportFile = createAction(
	NdcDestinationImportActions.UploadImportFile,
	props<ActionRequestPayload<NdcDestinationImportFileModel>>()
);

export const importFileUploaded = createAction(
	NdcDestinationImportActions.ImportFileUploaded,
	props<ActionResponsePayload<UploadFileResponse<ImportFileRecordsResult>>>()
);

export const loadValidationErrors = createAction(
	NdcDestinationImportActions.LoadValidationErrors,
	props<ActionRequestPayload<NdcDestinationFileDetailsFilterModel>>()
);

export const validationErrorsLoaded = createAction(
	NdcDestinationImportActions.ValidationErrorsLoaded,
	props<
		ActionResponsePayload<
			SearchResponse<NdcDestinationValidationErrorSearchModel>
		>
	>()
);

export const loadDateOverlaps = createAction(
	NdcDestinationImportActions.LoadDateOverlaps,
	props<
		ActionRequestPayload<
			FilterSearchRequest<NdcDestinationFileDetailsFilterModel>
		>
	>()
);

export const dateOverlapsLoaded = createAction(
	NdcDestinationImportActions.DateOverlapsLoaded,
	props<
		ActionResponsePayload<SearchResponse<NdcDestinationOverlapPairModel>>
	>()
);

export const clearDateOverlaps = createAction(
	NdcDestinationImportActions.ClearDateOverlaps
);

export const autoResolveDateOverlap = createAction(
	NdcDestinationImportActions.AutoResolveDateOverlap,
	props<ActionRequestPayload<AutoResolveExistingNdcDestinationModel>>()
);

export const dateOverlapAutoResolved = createAction(
	NdcDestinationImportActions.DateOverlapAutoResolved
);

export const updateSystemTerminationDate = createAction(
	NdcDestinationImportActions.UpdateSystemTerminationDate,
	props<
		ActionRequestPayload<UpdateExistingNdcDestinationTerminationDateModel>
	>()
);

export const systemTerminationDateUpdated = createAction(
	NdcDestinationImportActions.SystemTerminationDateUpdated
);

export const updateImportedOverlapRecord = createAction(
	NdcDestinationImportActions.UpdateImportedOverlapRecord,
	props<ActionRequestPayload<UpdateImportedNdcDestinationRecordModel>>()
);

export const importedOverlapRecordUpdated = createAction(
	NdcDestinationImportActions.ImportedOverlapRecordUpdated
);

export const deleteImportedOverlapRecord = createAction(
	NdcDestinationImportActions.DeleteImportedOverlapRecord,
	props<ActionRequestPayload<DeleteImportedNdcDestinationRecordModel>>()
);

export const importedOverlapRecordDeleted = createAction(
	NdcDestinationImportActions.ImportedOverlapRecordDeleted
);

export const bulkAutoFixDateOverlaps = createAction(
	NdcDestinationImportActions.BulkAutoFixDateOverlaps,
	props<ActionRequestPayload<NdcDestinationFileDetailsFilterModel>>()
);

export const dateOverlapsBulkAutoFixed = createAction(
	NdcDestinationImportActions.DateOverlapsBulkAutoFixed
);

export const removeImportFile = createAction(
	NdcDestinationImportActions.RemoveImportFile,
	props<ActionRequestPayload<number>>()
);

export const importFileRemoved = createAction(
	NdcDestinationImportActions.ImportFileRemoved
);

export const errorOccurred = createAction(
	NdcDestinationImportActions.ErrorOccurred
);
